import { createContext, useContext, useEffect, useState } from "react";
import { adminApi, clearToken, hasToken, saveToken } from "@/admin/adminApi";

const Ctx = createContext({ me: null, loading: true, login: () => {}, logout: () => {} });

export function AdminAuthProvider({ children }) {
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    if (!hasToken()) {
      setLoading(false);
      return;
    }
    adminApi
      .get("/me")
      .then((r) => alive && setMe(r.data))
      .catch(() => alive && setMe(null))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, []);

  async function login(email, password) {
    const { data } = await adminApi.post("/login", { email, password });
    saveToken(data.access_token);
    setMe({ email: data.email, role: data.role });
    return data;
  }

  function logout() {
    clearToken();
    setMe(null);
    window.location.href = "/admin/login";
  }

  return <Ctx.Provider value={{ me, loading, login, logout }}>{children}</Ctx.Provider>;
}

export function useAdminAuth() {
  return useContext(Ctx);
}
